import { magic } from '@gig/magic-sdk';
import { ACCOUNT_PEP_BLOCK_QUERY } from '@gig/magic-messages';
import { ConsentName } from '@gig/magic-sdk/dist/adapter/users/userPendingConsents';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const CONSENTS_NAMESPACE = "CONSENTS_NAMESPACE";
const SET_PENDING_CONSENTS = "SET_PENDING_CONSENTS";
const consentGetters = {
  pendingConsents(state) {
    return state.pendingConsents.filter(({ isMandatory, name }) => {
      return isMandatory && name !== ConsentName.DETAILS_REVERIFICATION;
    });
  }
};
const consentActions = {
  clearPendingConsents({
    commit
  }) {
    commit(SET_PENDING_CONSENTS, []);
  },
  fetchPendingConsents(_0, _1) {
    return __async(this, arguments, function* ({ commit }, language) {
      const isPepBlocked = yield window.queryBus.query(ACCOUNT_PEP_BLOCK_QUERY);
      if (isPepBlocked) {
        return;
      }
      const consents = yield magic.methods.users.getUserConsents(language);
      if (!!magic.session.getUser()) {
        commit(SET_PENDING_CONSENTS, consents.filter(({ consented }) => !consented));
      }
      return consents;
    });
  }
};
const consent = {
  namespaced: true,
  state: {
    pendingConsents: []
  },
  getters: consentGetters,
  actions: consentActions,
  mutations: {
    [SET_PENDING_CONSENTS](state, consents) {
      state.pendingConsents = consents;
    }
  }
};

export { CONSENTS_NAMESPACE, SET_PENDING_CONSENTS, consent, consentActions, consentGetters };
